import { Injectable, Type } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { IDynamicallyCreatedComponent } from '../core-data-model/DynamicallyCreated.component';
import { OrderedSet } from '../core-data-model/OrderedSet';

export type ModalBody = {
    type: Type<IDynamicallyCreatedComponent>;
    properties?: any;
    events?: any;
};

export type ModalContentType = {
    className?: string;
    TRtitle?: {
        displayString: string;
        linksTo?: {
            path: string;
            id: string;
        };
    };
    body: ModalBody;
};

export type ModalDataType = {
    id: string | number;
    content: ModalContentType;
    closeCallback?: Function;
};

@Injectable({ providedIn: 'root' })
export class ModalsService {
    public topModal$: Observable<ModalDataType>;
    private topModalSubject: Subject<ModalDataType>;

    private modalsOpen: OrderedSet<ModalDataType>;

    constructor() {
        this.modalsOpen = new OrderedSet([], 10);

        this.topModalSubject = new Subject<ModalDataType>();
        this.topModal$ = this.topModalSubject.asObservable();
    }

    openModal(
        modalId: string | number,
        content: ModalContentType,
        closeCallback: Function = null
    ): void {
        this.modalsOpen.updateArrayTop({
            content,
            closeCallback,
            id: modalId
        });
        this.topModalSubject.next(this.modalsOpen.getArray()[0]);
    }

    /**
     * Closes the modal with the given id.
     * If id is not given, it closes the most recently opened modal.
     *
     * @param modalId
     */
    closeModal(
        modalId: string | number = this.modalsOpen.first().id,
        fireCallback = true
    ): void {
        const elementToRemove = this.modalsOpen.removeElement(
            (modal) => modal.id === modalId
        );
        if (fireCallback && elementToRemove && elementToRemove.closeCallback) {
            elementToRemove.closeCallback();
        }
        if (this.modalsOpen.getArray().length > 1) {
            this.topModalSubject.next(this.modalsOpen.getArray()[0]);
        } else {
            this.modalsOpen.clear();
            this.topModalSubject.next(null);
        }
    }

    closeCurrentModal(fireCallback: boolean) {
        this.closeModal(this.modalsOpen.first().id, fireCallback);
    }
}
